import React, { useContext } from "react";
import AppContext from "../context/context";
import { Link } from "react-router-dom";
import icon from "../assets/images/icons/right icon.webp";
import darkIcon from "../assets/images/icons/dark right icon.webp";
import "../App.scss";

import { SideBar, Button, Blur } from "../styles/styles";

function Sidebar() {
  const { menu, navActive, handleClick, navDark } = useContext(AppContext);
  return (
    <>
      <SideBar className={menu ? "" : "sidebar"}>
        <div className="box">
          <Link
            id="home"
            to="/"
            className={`${navActive === "home" ? "active" : ""}`}
            onClick={handleClick}
          >
            Home
          </Link>
          <Link
            to="/about"
            id="about"
            onClick={handleClick}
            className={`${navActive === "about" ? "active" : ""}`}
          >
            About
          </Link>
          <Button className="dark">
            <a
              href="mailto:contact@abrahamkolade.com"
              className="p"
              target="_blank"
              rel="noreferrer noopener"
            >
              Let's Talk
            </a>
            {menu ? (
              <img src={icon} alt="icon" />
            ) : navDark ? (
              <img src={darkIcon} alt="icon" />
            ) : (
              <img src={icon} alt="icon" />
            )}
          </Button>
        </div>
      </SideBar>
      {menu && (
        <Blur>
          <div className="non"></div>
        </Blur>
      )}
    </>
  );
}

export default Sidebar;
